package com.example.positionahead.model

import com.example.positionahead.model.RecommendationAction

data class PortfolioHealth(
    val score: Int,
    val highlights: List<HealthReason>,
    val gaps: List<PortfolioGap>,
)

data class HealthReason(
    val title: String,
    val detail: String,
    val isPositive: Boolean,
)

data class PortfolioGap(
    val title: String,
    val currentLevel: String, // e.g. "Low exposure", "Strong exposure"
    val description: String,
    val recommendedSymbols: List<String> = emptyList()
)

enum class PositionSignal {
    HOLD,
    WATCH,
    REVIEW,
    REDUCE,
    SELL
}

data class PositionAnalysis(
    val symbol: String,
    val signal: PositionSignal,
    val reasonsToHold: List<String>,
    val thingsToWatch: List<String>,
    val sellTriggers: List<String>,
    val sellCase: SellCase? = null
)

data class SellCase(
    val portfolioReason: String? = null,
    val performanceReason: String? = null,
    val fundamentalReason: String? = null,
    val technicalReason: String? = null,
    val opportunityReason: String? = null,
    val taxReason: String? = null,
)

data class CapitalScenario(
    val title: String,
    val allocations: List<Pair<String, Double>>,
    val description: String
)

data class HomeState(
    val portfolioValue: Double,
    val dayChange: Double,
    val dayChangePercent: Double,
    val attentionItems: List<AttentionItem>,
    val opportunities: List<Recommendation>,
    val healthScore: Int
)

data class AttentionItem(
    val title: String,
    val detail: String,
    val symbol: String? = null,
    val type: AttentionType
)

enum class AttentionType {
    WARNING,
    INFO,
    SUCCESS
}
